/**
 * Campaign artwork for country-specific affiliate links.
 *
 * Add or replace `image` with an image from the WordPress media library for a
 * country.  The component deliberately has a flag-based fallback, so a newly
 * added destination never renders as an empty card while its artwork is being
 * prepared.
 */
export type CountryHero = {
  landmark: string
  image?: string
  accent: string
}

export const countryHeroes: Record<string, CountryHero> = {
  CN: {
    landmark: 'Great Wall of China',
    accent: '#b91c1c',
    image: chinaGreatWall,
  },
  JP: {
    landmark: 'Cherry blossoms in Japan',
    accent: '#db2777',
    image: japanCherryBlossom,
  },
  KR: { landmark: 'Seoul skyline', accent: '#2563eb' },
  TH: { landmark: 'Thai temples', accent: '#d97706' },
  VN: { landmark: 'Ha Long Bay', accent: '#0f766e' },
  ES: { landmark: 'Spanish coast', accent: '#c2410c' },
  FR: { landmark: 'Parisian streets', accent: '#4338ca' },
  IT: { landmark: 'Italian landmarks', accent: '#15803d' },
  US: { landmark: 'American cities', accent: '#1d4ed8' },
}

export const getCountryHero = (countryCode: string): CountryHero =>
  countryHeroes[countryCode.toUpperCase()] ?? {
    landmark: 'Stay connected on your trip',
    accent: '#0f766e',
  }
import chinaGreatWall from '~/assets/images/china-great-wall-hero.jpg'
import japanCherryBlossom from '~/assets/images/japan-cherry-blossom-hero.jpg'
